import { Box, Container, Divider, List, ListItem, ListItemButton, ListItemText, Typography } from '@mui/material'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import { DetailContainer, NavContent, TextContent } from '../../../../shared/styles/HelpCenterStyles'
import useSectionStart, { SectionData } from '../hooks/useSectionStart'

const SectionStartQuestion = () => {
  const { section, questionid } = useParams<{ section: string; questionid: string }>()
  const [iQuestion, setIQuestion] = useState<number>(() => {
    const id = Number(questionid)
    return isNaN(id) ? 0 : id
  })

  const data: SectionData = useSectionStart()

  const currentSection = useMemo(() => {
    if (!section) return undefined
    const sectionObject = data.client.find((s: any) => s[section] !== undefined)
    return sectionObject ? sectionObject[section] : undefined
  }, [data.client, section])

  const handleInfo = (newValue: number) => {
    setIQuestion(newValue)
  }

  if (!currentSection) {
    return null
  }

  const selectedQuestion = currentSection.content[iQuestion]

  return (
    <Container sx={{ padding: 0, marginTop: 6.25 }} maxWidth="xl">
      <Container maxWidth="md">
        <DetailContainer sx={{ flexWrap: 'wrap', mt: 7, mb: 15 }}>
          <NavContent>
            <Typography variant="subtitle1">{currentSection.title}</Typography>
            <List component="nav">
              {currentSection.content.map((item: any, index: number) => (
                <div key={item.question}>
                  <ListItem disablePadding>
                    <ListItemButton selected={index === iQuestion} onClick={() => handleInfo(index)}>
                      <ListItemText primary={item.question} />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </div>
              ))}
            </List>
          </NavContent>

          <TextContent sx={{ pb: 4 }}>
            <Box sx={{ mb: 3 }}>
              <ButtonBack />
            </Box>

            {selectedQuestion && (
              <div>
                <Box sx={{ mb: 7 }}>
                  <Typography variant="h4" sx={{ fontWeight: 300 }}>
                    {selectedQuestion.question}
                  </Typography>
                </Box>
                {selectedQuestion.answer.map((answer: string, index: number) => (
                  <Typography key={index} dangerouslySetInnerHTML={{ __html: answer }} />
                ))}
              </div>
            )}
          </TextContent>
        </DetailContainer>
      </Container>
    </Container>
  )
}

export default SectionStartQuestion
